module.exports = __webpack_public_path__ + "img/Tablet - 27.af4eb03f.png";